import { http, HttpResponse } from 'msw'

export const mockActivateCustomerCard = http.put(
  '/my-business/api/agency/v1/customers/:customerId/cards/:cardId/activate',
  () =>
    HttpResponse.json({ timestamp: new Date().toISOString() }, { status: 200 }),
)
